var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRewards = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    fillRule: "evenodd",
    d: "M21.166 6.167H19.17c.2-.397.313-.833.329-1.277A3 3 0 0 0 16.443 2 5.18 5.18 0 0 0 12 4.932a5.15 5.15 0 0 0-4.416-2.93h-.095A2.995 2.995 0 0 0 4.5 4.89v.055c.016.425.124.842.316 1.222H2.833A.833.833 0 0 0 2 7v2.5a.833.833 0 0 0 .833.833h18.333a.834.834 0 0 0 .833-.833V7a.833.833 0 0 0-.833-.833m-4.697-2.5a1.333 1.333 0 0 1 1.363 1.223 1.323 1.323 0 0 1-1.312 1.277h-3.289c.518-1.05 1.55-2.5 3.238-2.5M6.166 4.917a1.333 1.333 0 0 1 1.345-1.25c1.724.007 2.734 1.443 3.259 2.5H7.52a1.347 1.347 0 0 1-1.354-1.25m7.5 7.083v10h4.167a2.5 2.5 0 0 0 2.5-2.5V12zm-9.999 0h6.666v10H6.167a2.5 2.5 0 0 1-2.5-2.5z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRewards);
export { ForwardRef as ReactComponent };